module.exports = __webpack_public_path__ + "img/category_literature.b98a755.png";